import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t bg-white">
      <div className="container mx-auto px-4 py-6 text-sm text-gray-600">
        <div className="flex flex-col items-center text-center gap-3">
          <div>
            <div className="font-medium text-gray-700">南富良野支援ナビ</div>
            <div>© {year} Minamifurano Support Navi</div>
          </div>

          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
            <Link className="hover:text-gray-900" to="/privacy-policy">
              プライバシーポリシー
            </Link>
            <Link className="hover:text-gray-900" to="/contact">
              お問い合わせ
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
